export const DASHBOARD_NOTIFICATION_UPDATED_EVENT = "dashboard-notification-updated";

export function broadcastDashboardNotificationUpdate() {
  window.dispatchEvent(new CustomEvent(DASHBOARD_NOTIFICATION_UPDATED_EVENT));
}
